import { CredentialsChat } from "../model/credentials-chat";

const keyCredentials = window.location.href.split("/")[3].split("?")[0];

export function storeCredentials(credentials: CredentialsChat) {
  try {
    window.localStorage.setItem(
      keyCredentials,
      btoa(JSON.stringify(credentials))
    );
  } catch (error) {
    console.error(error);
  }
}

export function retrieveStoredCredentials(): CredentialsChat | null {
  try {
    const data = window.localStorage.getItem(keyCredentials);
    if (!data) {
      return null;
    }
    return JSON.parse(atob(data)) as CredentialsChat;
  } catch (e: any) {
    console.log(e);
    return null;
  }
}

export function clearCredentials() {
  try {
    window.localStorage.removeItem(keyCredentials);
  } catch (error) {
    console.error(error);
  }
}
